// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__g0_5b","layered":"styles_layered__mBwIW","thin":"styles_thin__uBoLO","secondary":"styles_secondary__eKbq3"};